import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Api } from './api.service';
import { Log } from '../utils/index';

@Injectable()
export class ActivationService {

  constructor(protected http: Api) {}

  @Log('green')
  activate(sim: string): Observable<any> {
    return this.http.post('activation', { sim: sim, action: 'activate'});
  }

  @Log('green')
  deactivate(sim: string): Observable<any> {
    return this.http.post('activation', { sim: sim, action: 'suspend'});
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/activation.service.ts